import { useMemo, useEffect } from "react";

const WarningIcon = () => (
  <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
  </svg>
);

const RouteIcon = () => (
  <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l5.553 2.776A1 1 0 0022 18.882V8.118a1 1 0 00-1.447-.894L15 10m0 7V10m0 0L9 7" />
  </svg>
);

const ArrowRightIcon = () => (
  <svg className="w-3 h-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
  </svg>
);

const CheckIcon = () => (
  <svg className="w-3 h-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={3}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
  </svg>
);

const CarIcon = () => (
  <svg className="w-3.5 h-3.5 text-gray-500" viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"/>
  </svg>
);
const PlaneIcon = () => (
  <svg className="w-3.5 h-3.5 text-gray-500" viewBox="0 0 24 24" fill="currentColor">
    <path d="M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z"/>
  </svg>
);
const TrainIcon = () => (
  <svg className="w-3.5 h-3.5 text-gray-500" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2c-4 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-4-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zM11 10H6V6h5v4zm5.5 7c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM18 10h-5V6h5v4z"/>
  </svg>
);
const BusIcon = () => (
  <svg className="w-3.5 h-3.5 text-gray-500" viewBox="0 0 24 24" fill="currentColor">
    <path d="M4 16c0 .88.39 1.67 1 2.22V20c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h8v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1.78c.61-.55 1-1.34 1-2.22V6c0-3.5-3.58-4-8-4s-8 .5-8 4v10zm3.5 1c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm9 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6H6V6h12v5z"/>
  </svg>
);

const MODE_META = {
  flights: { label: "Flight", color: "bg-blue-50 text-blue-700 border-blue-200",       Icon: PlaneIcon },
  flight:  { label: "Flight", color: "bg-blue-50 text-blue-700 border-blue-200",       Icon: PlaneIcon },
  trains:  { label: "Train",  color: "bg-emerald-50 text-emerald-700 border-emerald-200", Icon: TrainIcon },
  train:   { label: "Train",  color: "bg-emerald-50 text-emerald-700 border-emerald-200", Icon: TrainIcon },
  buses:   { label: "Bus",    color: "bg-orange-50 text-orange-700 border-orange-200",  Icon: BusIcon },
  bus:     { label: "Bus",    color: "bg-orange-50 text-orange-700 border-orange-200",  Icon: BusIcon },
  road:    { label: "Drive",  color: "bg-gray-50 text-gray-700 border-gray-200",        Icon: CarIcon },
  drive:   { label: "Drive",  color: "bg-gray-50 text-gray-700 border-gray-200",        Icon: CarIcon },
  ferry:   { label: "Ferry",  color: "bg-teal-50 text-teal-700 border-teal-200",        Icon: CarIcon },
};

const getModeMeta = (mode) =>
  MODE_META[String(mode).toLowerCase()] ||
  { label: mode || "?", color: "bg-gray-50 text-gray-600 border-gray-200", Icon: CarIcon };

const ModeChip = ({ mode }) => {
  const meta = getModeMeta(mode);
  const { Icon } = meta;
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 text-xs font-semibold rounded-md border ${meta.color}`}>
      <Icon />
      {meta.label}
    </span>
  );
};

const SegmentChain = ({ segments }) => (
  <div className="flex items-center flex-wrap gap-1.5">
    {segments.map((s, i) => (
      <div key={i} className="flex items-center gap-1.5">
        <div className="flex items-center gap-1.5 px-2.5 py-1 bg-white border border-gray-200 rounded-md">
          <ModeChip mode={s.mode} />
          <span className="text-xs text-gray-700 truncate max-w-[120px]">{s.to}</span>
          {(s.distanceKm != null) && (
            <span className="text-[10px] text-gray-400 font-medium">{s.distanceKm}km</span>
          )}
        </div>
        {i < segments.length - 1 && <ArrowRightIcon />}
      </div>
    ))}
  </div>
);

const OptionRow = ({ option, selected, onSelect, compact = false }) => {
  return (
    <button
      type="button"
      onClick={onSelect}
      className={`w-full text-left p-3 rounded-lg border transition-all duration-150 cursor-pointer ${
        selected
          ? "bg-teal-50 border-teal-300 ring-1 ring-teal-200"
          : "bg-white border-gray-200 hover:border-gray-300 hover:bg-gray-50"
      }`}
    >
      <div className="flex items-start gap-3">
        <div className={`mt-0.5 w-4 h-4 rounded-full border-2 flex items-center justify-center shrink-0 ${
          selected ? "border-teal-500" : "border-gray-300"
        }`}>
          {selected && <div className="w-2 h-2 rounded-full bg-teal-500" />}
        </div>
        <div className="flex-1 min-w-0">
          <div className={compact ? "mb-0.5" : "mb-1.5"}>
            <SegmentChain segments={option.segments || []} />
          </div>
          {option.description && (
            <p className="text-[11px] text-gray-500 leading-relaxed">
              {option.description}
            </p>
          )}
        </div>
      </div>
    </button>
  );
};

const LegCard = ({ leg, selectedOptionId, onSelect }) => {
  const optionsByMode = leg.optionsByMode || {};
  const modeOrder = leg.modeOrder && leg.modeOrder.length
    ? leg.modeOrder
    : Object.keys(optionsByMode);

  const totalOptions = modeOrder.reduce((s, m) => s + (optionsByMode[m]?.length || 0), 0);
  const isFailing = totalOptions === 0;
  const isAutoOnly = totalOptions === 1;

  const cardColor = isFailing
    ? "bg-amber-50 border-amber-100"
    : isAutoOnly
      ? "bg-gray-50 border-gray-100"
      : "bg-white border-gray-200";

  return (
    <div className={`p-4 rounded-xl border ${cardColor} shadow-sm`}>
      <div className="flex items-start gap-3 mb-3">
        <div className={`w-5 h-5 rounded-full flex items-center justify-center shrink-0 mt-0.5 ${
          isFailing ? "bg-amber-200 text-amber-800" : isAutoOnly ? "bg-gray-200 text-gray-600" : "bg-teal-100 text-teal-700"
        }`}>
          {isFailing ? <WarningIcon /> : isAutoOnly ? <CheckIcon /> : <RouteIcon />}
        </div>
        <div className="min-w-0 flex-1">
          <div className="flex items-baseline gap-2 flex-wrap">
            <p className="text-sm font-semibold text-gray-800">{leg.legLabel}</p>
            {leg.distanceKm != null && (
              <span className="text-[11px] text-gray-400 font-medium">~{leg.distanceKm}km</span>
            )}
            {isAutoOnly && (
              <span className="text-[10px] text-gray-500 font-medium uppercase tracking-wide">Auto</span>
            )}
          </div>
          {isFailing && (
            <p className="text-xs text-amber-800 mt-1 leading-relaxed">
              No viable transport found for your selected modes — we&apos;ll use the best estimate.
            </p>
          )}
        </div>
      </div>

      {isFailing ? null : (
        <div className="space-y-3.5">
          {modeOrder.map((mode) => {
            const opts = optionsByMode[mode] || [];
            if (opts.length === 0) return null;
            const meta = getModeMeta(mode);
            return (
              <div key={mode}>
                <div className="flex items-center gap-1.5 mb-1.5 pl-1">
                  <ModeChip mode={mode} />
                  <span className="text-[10px] text-gray-400 font-medium uppercase tracking-wider">
                    {meta.label} {opts.length > 1 ? `(${opts.length} options)` : ""}
                  </span>
                </div>
                <div className="space-y-1.5">
                  {opts.map((opt) => (
                    <OptionRow
                      key={opt.id}
                      option={opt}
                      selected={opt.id === selectedOptionId}
                      onSelect={() => onSelect(leg.key, opt.id)}
                      compact={opts.length === 1}
                    />
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default function Step4TransportForm({ validation, selected, onSelect }) {
  useEffect(() => {
    if (validation?.legPlans && selected) {
      validation.legPlans.forEach(leg => {
        if (!selected[leg.key]) {
          const optionsByMode = leg.optionsByMode || {};
          const modeOrder = leg.modeOrder || Object.keys(optionsByMode);
          const firstMode = modeOrder[0];
          if (firstMode && optionsByMode[firstMode] && optionsByMode[firstMode].length > 0) {
            onSelect(leg.key, optionsByMode[firstMode][0].id);
          }
        }
      });
    }
  }, [validation, selected, onSelect]);

  if (!validation) return null;

  const { legPlans = [], transportModes = [] } = validation;
  const legs = Array.isArray(legPlans) ? legPlans : [];
  const choiceCount = legs.filter((l) => l.needsUserChoice && l.totalOptions > 1).length;

  return (
    <div className="space-y-6">
      <div className="bg-teal-50 border border-teal-150 rounded-xl p-4">
        <p className="text-sm text-teal-800 leading-relaxed font-medium">
          {choiceCount > 0
            ? `${choiceCount === 1 ? "1 leg has" : `${choiceCount} legs have`} multiple options. Pick what suits you — the rest are auto-selected.`
            : "Review your travel connections below. Ready to see your full itinerary?"}
        </p>
      </div>

      {transportModes.length > 0 && (
        <div>
          <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2">
            Your Selected Modes
          </p>
          <div className="flex flex-wrap gap-1.5">
            {transportModes.map((m) => <ModeChip key={m} mode={m} />)}
          </div>
        </div>
      )}

      <div className="space-y-4">
        {legs.map((leg) => (
          <LegCard
            key={leg.key}
            leg={leg}
            selectedOptionId={selected[leg.key]}
            onSelect={onSelect}
          />
        ))}
      </div>
    </div>
  );
}
